// extracted by mini-css-extract-plugin
export default {"container":"tabs_container__nUyMe","icon":"tabs_icon__Jwq1Z","Active-btn":"tabs_Active-btn__op2ov","overlay":"tabs_overlay__4jmPu","showTabs":"tabs_showTabs__rpBs7"};